import controlPlaneApi from '../config/controlPlaneApi'
import {
  ControlPlaneSession,
  CreateOrganizationPayload,
  CreateOrganizationResult,
  OnboardedOrganization,
  OwnerProfile,
} from '../types/controlPlane'
import { License, LicensePlan } from '../types/license'

const AUTH_URL = '/control-plane/auth'
const ORGANIZATIONS_URL = '/control-plane/organizations'

export const signupEmailApi = async (payload: {
  email: string
  password: string
  firstName: string
  lastName: string
}): Promise<ControlPlaneSession> => {
  const response = await controlPlaneApi.post<ControlPlaneSession>(`${AUTH_URL}/signup`, payload)
  return response.data
}

export const loginEmailApi = async (payload: {
  email: string
  password: string
}): Promise<ControlPlaneSession> => {
  const response = await controlPlaneApi.post<ControlPlaneSession>(`${AUTH_URL}/login`, payload)
  return response.data
}

export const loginGoogleApi = async (idToken: string): Promise<ControlPlaneSession> => {
  const response = await controlPlaneApi.post<ControlPlaneSession>(`${AUTH_URL}/google`, { idToken })
  return response.data
}

export const fetchOwnerProfileApi = async (): Promise<OwnerProfile> => {
  const response = await controlPlaneApi.get<OwnerProfile>(`${AUTH_URL}/me`)
  return response.data
}

export const checkSlugApi = async (slug: string): Promise<{ slug: string; available: boolean }> => {
  const response = await controlPlaneApi.get(`${ORGANIZATIONS_URL}/check-slug`, { params: { slug } })
  return response.data
}

export const createOrganizationApi = async (
  payload: CreateOrganizationPayload
): Promise<CreateOrganizationResult> => {
  const response = await controlPlaneApi.post<CreateOrganizationResult>(ORGANIZATIONS_URL, payload)
  return response.data
}

export const listMyOrganizationsApi = async (): Promise<OnboardedOrganization[]> => {
  const response = await controlPlaneApi.get<OnboardedOrganization[]>(ORGANIZATIONS_URL)
  return response.data
}

export const getOrganizationApi = async (organizationId: string): Promise<OnboardedOrganization> => {
  const response = await controlPlaneApi.get<OnboardedOrganization>(`${ORGANIZATIONS_URL}/${organizationId}`)
  return response.data
}

export const getOrganizationLicenseApi = async (organizationId: string): Promise<License> => {
  const response = await controlPlaneApi.get<License>(`${ORGANIZATIONS_URL}/${organizationId}/license`)
  return response.data
}

export const changeOrganizationLicenseApi = async (
  organizationId: string,
  planKey: LicensePlan
): Promise<License> => {
  const response = await controlPlaneApi.put<License>(`${ORGANIZATIONS_URL}/${organizationId}/license`, {
    planKey,
  })
  return response.data
}
